$sidenavCollapsedWidth: 32px;
$sidenavExpandedWidth: 240px;

:host {
  height: 100%;
  width: 100%;
  background: inherit;

  .push-body-layout {
    height: 100%;
    display: flex;
    flex-direction: row;
    .push-body-sidenav {
      border-right: 1px solid var(--chart-101-pressed-dividers);
      width: $sidenavCollapsedWidth;
      padding: var(--spacer) calc(var(--spacer) / 2);
      position: relative;
      left: 0;
      height: 100%;
      .header {
        display: flex;
        height: 100%;
        min-height: calc(4 * var(--spacer));
        padding-left: calc(2 * var(--spacer));
        position: relative;
        margin-bottom: calc(4 * var(--spacer));
        .title {
          margin-right: calc(5 * var(--spacer));
          flex: 1;
          align-items: center;
          display: none;
        }
        .push-body-toggle {
          position: absolute;
          height: 100%;
          top: calc(var(--spacer) / 2);
          right: 0;
          cursor: pointer;
        }
      }
      .content {
        overflow: hidden;
        display: none;
        height: calc(100% - 64px);
        overflow-y: auto;
      }
    }
    .push-body-content {
      display: flex;
      flex-direction: column;
      flex: 1;
      .content {
        flex: 1;
      }
    }
  }
}

:host([isopen]) {
  .push-body-sidenav {
    width: var(--expanded-width, $sidenavExpandedWidth);
    padding: var(--spacer) 0 var(--spacer) 0;
    .header {
      height: auto;
      .title {
        display: flex;
      }
      .push-body-toggle {
        right: calc(2 * var(--spacer));
        height: calc(3 * var(--spacer));
      }
    }
    .content {
      display: block;
    }
  }
}

:host([resizable]) {
  .resize-handler {
    position: absolute;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: col-resize;
    width: calc(var(--spacer) * 4);
    span {
      position: absolute;
      transition: all 0.3s ease;
      color: var(--chart-300-icon-buttons);
      font-size: 16px;
    }
    &:hover {
      span {
        color: var(--blue-layout-400-primary);
      }
    }
  }
  .push-body-layout {
    .header {
      .push-body-toggle {
        right: 0px;
      }
    }
  }
}

:host([resizable][isOpen]) {
  .push-body-layout {
    .push-body-sidenav {
      padding: var(--spacer) calc(var(--spacer) + 4px) var(--spacer) 0;
    }
  }
}

:host([resizable='left']) {
  .resize-handler {
    left: -16px;
    &:after {
      left: 10px;
    }
    span {
      left: 20px;
    }
  }
}

:host([resizable='right']) {
  .resize-handler {
    right: -16px;
    &:after {
      right: 10px;
    }
    span {
      right: 20px;
    }
  }
}
